import { render, staticRenderFns } from "./CollapseButton.vue?vue&type=template&id=fb627d84"
import script from "./CollapseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CollapseButton.vue?vue&type=style&index=0&id=fb627d84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports